// extracted by mini-css-extract-plugin
module.exports = {"box":"ReCaptcha_box__SRwuH","boxContent":"ReCaptcha_boxContent__1dC0V"};